// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    LensConvex,
    Library,
    LibraryBig,
    LifeBuoy,
    Ligature,
    Lightbulb,
    LightbulbOff,
    Lighthouse,
    LineDotRightHorizontal,
    LineSquiggle,
    LineStyle,
    Link,
    Link2,
    Link2Off,
    List,
    ListCheck,
    ListChecks,
    ListChevronsDownUp,
    ListChevronsUpDown,
    ListClock,
    ListCollapse,
    ListEnd,
    ListFilter,
    ListFilterPlus,
    ListIndentDecrease,
    ListIndentIncrease,
    ListMinus,
    ListMusic,
    ListOrdered,
    ListPlus,
    ListRestart,
    ListSortAscending,
    ListSortDescending,
    ListStart,
    ListTodo,
    ListTree,
    ListVideo,
    ListX,
    Loader,
    LoaderCircle,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "lens-convex" through "loader-circle", inclusive. */
const shard: Record<string, LucideIcon> = {
    "lens-convex": LensConvex,
    library: Library,
    "library-big": LibraryBig,
    "life-buoy": LifeBuoy,
    ligature: Ligature,
    lightbulb: Lightbulb,
    "lightbulb-off": LightbulbOff,
    lighthouse: Lighthouse,
    "line-dot-right-horizontal": LineDotRightHorizontal,
    "line-squiggle": LineSquiggle,
    "line-style": LineStyle,
    link: Link,
    "link-2": Link2,
    "link-2-off": Link2Off,
    list: List,
    "list-check": ListCheck,
    "list-checks": ListChecks,
    "list-chevrons-down-up": ListChevronsDownUp,
    "list-chevrons-up-down": ListChevronsUpDown,
    "list-clock": ListClock,
    "list-collapse": ListCollapse,
    "list-end": ListEnd,
    "list-filter": ListFilter,
    "list-filter-plus": ListFilterPlus,
    "list-indent-decrease": ListIndentDecrease,
    "list-indent-increase": ListIndentIncrease,
    "list-minus": ListMinus,
    "list-music": ListMusic,
    "list-ordered": ListOrdered,
    "list-plus": ListPlus,
    "list-restart": ListRestart,
    "list-sort-ascending": ListSortAscending,
    "list-sort-descending": ListSortDescending,
    "list-start": ListStart,
    "list-todo": ListTodo,
    "list-tree": ListTree,
    "list-video": ListVideo,
    "list-x": ListX,
    loader: Loader,
    "loader-circle": LoaderCircle,
};

export default shard;
